import FillButton from '@components/Buttons/Fill';
import styled from '@emotion/styled';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  align-items: center;
  height: 100%;
  align-items: center;
  min-width: 1024px;
`;

export const Content = styled.div`
  display: flex;
  margin: auto;
  align-items: center;
  display: flex;
  flex-direction: column;
`;

export const StartMeeting = styled(FillButton)`
  background-color: #ffffff;
  color: #000000;
  padding: 6px;
  width: 100px;
  border-radius: 6px;
  font-size: 13px;
  margin-top: 50px;
`;

export const ContentDimmedWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
